import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useRef } from "react";
import { auth } from "@/lib/firebase";
import { useOnboardingStatus } from "./useOnboardingStatus";

/**
 * Redirect authenticated users without completed onboarding to /onboarding
 * Skips redirect if already on /onboarding.
 */
export function useOnboardingGate() {
  const { loading, completed } = useOnboardingStatus();
  const nav = useNavigate();
  const loc = useLocation();
  const navigatedRef = useRef(false);

  useEffect(() => {
    if (loading || navigatedRef.current) return;
    const u = auth.currentUser;
    if (!u) return;
    if (!completed && !loc.pathname.startsWith("/onboarding")) {
      navigatedRef.current = true;
      nav("/onboarding", { replace: true });
    }
  }, [loading, completed, loc.pathname, nav]);
}
